import React from 'react';
import { Inbox } from 'lucide-react';

/**
 * AgGridEmptyOverlay
 * Standardized empty state component rendered inside AG-Grid when no rows are available.
 */
const AgGridEmptyOverlay = (props) => {
    const title = props?.noRowsTitle || props?.title || 'No data found';
    const message = props?.noRowsMessage || props?.message || 'No records match your criteria.';

    return (
        <div
            className="flex flex-col items-center justify-center p-8 text-center pointer-events-none select-none"
            role="status"
            aria-live="polite"
        >
            <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center mb-3 text-slate-400">
                <Inbox className="w-5 h-5 stroke-[1.5]" />
            </div>
            <h4 className="text-sm font-semibold text-slate-700">{title}</h4>
            {message && (
                <p className="text-xs text-slate-500 mt-1 max-w-sm">{message}</p>
            )}
        </div>
    );
};

export default AgGridEmptyOverlay;

